import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiPencilFill } from '@remixicon/react';

export interface ButtonIconEditProps {
  variant: 'tertiary' | 'primary' | 'secondary';
  size: 'small' | 'medium';
  isDisabled?: boolean;
  onClick: () => void;
}

export const ButtonIconEdit = (props: ButtonIconEditProps) => {
  const { variant, size, isDisabled, onClick } = props;
  return (
    <TooltipTrigger delay={100}>
      <ButtonIcon
        icon={<RiPencilFill />}
        variant={variant}
        size={size}
        onClick={onClick}
        isDisabled={isDisabled ?? false}
      />
      <Tooltip placement="bottom">Edit</Tooltip>
    </TooltipTrigger>
  );
};
